import React from 'react';
import PropTypes from 'prop-types';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';
import './attentionModal.scss';

const WarningModal = ({
    showModal,
    toggleModal,
    title,
    bodyComponent,
    buttonsComponent,
}) => (
    <Modal
        className="attention-modal"
        isOpen={showModal}
        toggle={toggleModal}
        centered
        data-testid="attention_modal"
        container="div#root"
    >
        <ModalHeader className="attention-header" toggle={toggleModal}>
            <span className="attention-text">{title || 'Attention!'}</span>
        </ModalHeader>
        <ModalBody className="attention-body">{bodyComponent}</ModalBody>
        <ModalFooter className="attention-footer">
            {buttonsComponent || (
                <Button
                    className="attention-ok-btn"
                    onClick={() => {
                        toggleModal();
                    }}
                >
                    OK
                </Button>
            )}
        </ModalFooter>
    </Modal>
);
WarningModal.propTypes = {
    showModal: PropTypes.bool.isRequired,
    toggleModal: PropTypes.func.isRequired,
    title: PropTypes.string,
    bodyComponent: PropTypes.node,
    buttonsComponent: PropTypes.node,
};
WarningModal.defaultProps = {
    title: 'Attention!',
    bodyComponent: null,
    buttonsComponent: null,
};
export default WarningModal;
